import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherSubjectTypeId {
  GUEST = 'guest',
  COMPANY = 'company',
  SUPPLIER = 'supplier',
}

export class GiftVoucherSubjectType extends Codebook<GiftVoucherSubjectTypeId> {
  static readonly GUEST = new GiftVoucherSubjectType(GiftVoucherSubjectTypeId.GUEST, () =>
    $t('Guest'),
  )
  static readonly COMPANY = new GiftVoucherSubjectType(GiftVoucherSubjectTypeId.COMPANY, () =>
    $t('Company'),
  )
  static readonly SUPPLIER = new GiftVoucherSubjectType(GiftVoucherSubjectTypeId.SUPPLIER, () =>
    $t('Supplier'),
  )

  private constructor(
    id: GiftVoucherSubjectTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
